const getters = {
  getPrivacyPolicyContent: (state) => state.content.privacyPolicy,
  getTermsConditionsContent: (state) => state.content.termsConditions,
  getHeaderContent: (state) => state.content.header,
  getFooterContent: (state) => state.content.footer,
  getHomeContent: (state) => state.content.home,
  getCookiePolicyContent: (state) => state.content.cookiePolicy,
};

export default getters;
